import "./SalesList.scss";

import SalesList from "./SalesList";

export default SalesList;
